import { useQuery } from 'react-query';
import { CheckoutAPI } from 'api/checkout';
import { CHECKOUT } from 'helpers/constants';

export default function useCheckoutForUser(id) {
  return useQuery([CHECKOUT, id], () => CheckoutAPI.getCheckoutInfoForUser(id));
}
